
export let formLocalStorage= {
    email: '',
    Name:'',
    Role:'',
    token:''
}